import { Component, ComponentFactoryResolver, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { surveysBlocks } from '../../commons/config';
import { from } from 'rxjs';

// Services
import { DashboardService } from '../../services/dashboard.service';
import { ModuleService } from '../../services/modules.service';
import { StorageService } from '../../services/storage.service';
import { GlobalFlagsService } from '../../services/global-flags.service';
import { DialogComponent } from '../commons/dialog/dialog.component';
import { DialogHistoryComponent } from '../commons/dialog-history-table/dialog-history-table.component';

// Models
import { Form } from '../../models/form';
import { OtherSurveys } from '../../models/otherSurveys';
import { User } from '../../models/user';

// Mockups
import { DashboardMockups } from './dashboard.mockup';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss', './dashboard.component.medium.scss','../../styles/csc-theme.scss'],
  providers: []
})
export class DashboardComponent implements OnInit, OnDestroy {

  cerLogo = 'menu_logo.png';

  currentUser: User;
  modules: any;

  isLoadingForms = false;
  isLoadingBlogs = false;

  trackerSurvey;
  trackerSurveyAvailable = null;
  showTrackerForm = null;
  formsArray = null;
  otherSurveys = null;
  blogsArray = null;
  errorMsg = null;

  blocksConfig = surveysBlocks;

  // Other Surveys rendered on dashboard
  otherSurveysLength = 1;

  res = null;
  sub;
  fromLogin = false;

  constructor(private dashboardService: DashboardService,
    private moduleService: ModuleService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef,
    private router: Router,
    private route: ActivatedRoute,
    private globalFlagsService: GlobalFlagsService,
    private dialog: MatDialog,
    private storageService: StorageService) {

    this.modules = localStorage.getItem('modules');
  }

  get isAboutIoAvailable() {
    return this.moduleService.isAboutIoAvailable();
  }

  get isRegistryAvailable() {
    return this.moduleService.isRegistryAvailable();
  }

  get isCustomSurveysAvailable() {
    return this.moduleService.isCustomSurveysAvailable();
  }

  get isLivingCancerAvailable() {
    return this.moduleService.isLivingCancerAvailable();
  }

  get showDistressScreener() {
    return true;
  }

  get getTrackerSurveyState() {
    const formMessage = 'Tracking Symptoms';
    if (this.trackerSurvey.currentSurvey.startNewInstance) {
      return `Start ${formMessage}`;
    } else {
      return `Continue ${formMessage}`;
    }
  }

  ngOnInit() {
    this.sub = this.route
      .queryParams
      .subscribe(params => {
        const errorMsg = params['errorMsg'];
        if (errorMsg) {
          this.globalFlagsService.pushErrorAlert({ errorMsg });
          this.router.navigate(['/'], { queryParams: {} });
        }
      });
    this.fromLogin = this.globalFlagsService.isFromLogin;
    // Set loading flags
    this.isLoadingBlogs = true;
    this.isLoadingForms = true;

    // Init objects with Mocks
    this.formsArray = DashboardMockups.formsArrayBE;
    this.blogsArray = DashboardMockups.blogsArrayBE;

    const dashboard = from(this.dashboardService.getDashboard());
    dashboard
    .subscribe((db) => {
    this.storageService.setIdHospital(db.hospitalId);
            this.storageService.setClinicName(db.clinicName);
            this.storageService.setUsername(db.userFirstName);
            this.storageService.setExternalLinks(db);
            this.storageService.setBlogs(db.blogs);
            this.storageService.setRegistryExperience(db.registryDashboardLink);
            this.formsArray = [];
            this.res = db;
            if (db.trackerSurveyDashboardView) {
              if (db.trackerSurveyDashboardView.currentSurvey || db.trackerSurveyDashboardView.completedSurveys.length > 0) {
                this.showTrackerForm = true;
              }
            }
            if (this.res.trackerSurveyDashboardView?.currentSurvey) {
              this.trackerSurveyAvailable = true;
              this.trackerSurvey = db.trackerSurveyDashboardView;
            }
            this.isLoadingForms = false;
            if (db.doSymptomTrackerOnLogon && this.fromLogin) {
              const data = {
                message: 'Ready to fill out your Side Effect Checklist?',
                cancelButton: true
              };
              const dialogRef = this.dialog.open(DialogComponent, { data });
              dialogRef.afterClosed().subscribe(result => {
                if (result) {
                  this.goToForm(this.trackerSurvey.currentSurvey.formId, true);
                }
              });
            }
    },
          err => {
            const errMsg = err.message ? err.message : 'Server has encountered a problem. <br>Sorry for inconvenience, we are working on it';
            const data = { message: `${errMsg}. Please try again.` };
            //this.dialog.open(DialogComponent, { data });
            //this.router.navigate(['/error']);
            //throw err;
          }
          );
  }

  ngOnDestroy() {
    this.globalFlagsService.setIsFromLogin(false);
  }

  getBlogs(): any {
    return JSON.parse(localStorage.getItem('blogs'));
  }

  pushForm(data: any) {
    this.formsArray.push(new Form(data));
  }

  viewHistory(history: any, block: any) {
    const data = { history, block };
    this.dialog.open(DialogHistoryComponent, { data });
  }

  openLink(url: string) {
    window.open(url, '_blank');
  }

  pushOtherSurveys(data: any) {
    this.otherSurveys = new OtherSurveys(data[0]);
  }

  goToForm(formInstanceId: any, trackerSurvey: any = false) {
    this.router.navigate(['/form/startInstance/', formInstanceId], {
      queryParams: {
        trackerSurvey
      }
    });
  }

}
